<template>
    <div>
        <div v-if="!show_historico">
            <div class="row justify-content-between px-3">
                <h4>Informações de Contato da Família</h4>
                <div>
                    <a
                        class="font-weight-light font-italic"
                        role="button"
                        @click="show_historico = true"
                    >
                        <i class="fas fa-history"></i> Histórico de Contatos
                    </a>
                </div>
            </div>
            <div class="row mt-3">
                <form-input
                    v-model="contato.telefone_um"
                    v-mask="'(##) # ####-####'"
                    grid="6"
                    label="Telefone Um"
                />

                <form-select
                    grid="6"
                    v-model="contato.telefone_um_tipo"
                    :itens="$root.arrays.tipo_contato_telefone"
                    label="Tipo do Telefone Um"
                />

                <form-input
                    v-model="contato.resp_tel_um"
                    grid="12"
                    label="Descrição"
                />

                <form-toggle
                    v-model="contato.telefone_um_sms"
                    mt="1"
                    label="Permite o envio de SMS?"
                />
            </div>

            <div class="row mt-3">
                <form-input
                    grid="6"
                    v-model="contato.telefone_dois"
                    v-mask="'(##) # ####-####'"
                    label="Telefone Dois"
                />

                <form-select
                    grid="6"
                    v-model="contato.telefone_dois_tipo"
                    :itens="$root.arrays.tipo_contato_telefone"
                    label="Tipo do Telefone Dois"
                />

                <form-input
                    v-model="contato.resp_tel_dois"
                    grid="12"
                    label="Descrição"
                />

                <form-toggle
                    mt="1"
                    v-model="contato.telefone_dois_sms"
                    label="Permite o envio de SMS?"
                />
            </div>

            <div class="row mt-3">
                <form-input
                    grid="6"
                    v-model="contato.telefone_tres"
                    v-mask="'(##) # ####-####'"
                    label="Telefone Três"
                />

                <form-select
                    grid="6"
                    v-model="contato.telefone_tres_tipo"
                    :itens="$root.arrays.tipo_contato_telefone"
                    label="Tipo do Telefone Três"
                />

                <form-input
                    v-model="contato.resp_tel_tres"
                    grid="12"
                    label="Descrição"
                />

                <form-toggle
                    mt="1"
                    v-model="contato.telefone_tres_sms"
                    label="Permite o envio de SMS?"
                />
            </div>

            <div class="row mt-3">
                <form-input
                    grid="6"
                    v-model="contato.telefone_quatro"
                    v-mask="'(##) # ####-####'"
                    label="Telefone Quatro"
                />

                <form-select
                    grid="6"
                    v-model="contato.telefone_quatro_tipo"
                    :itens="$root.arrays.tipo_contato_telefone"
                    label="Tipo do Telefone Quatro"
                />

                <form-input
                    v-model="contato.resp_tel_quatro"
                    grid="12"
                    label="Descrição"
                />

                <form-toggle
                    mt="1"
                    v-model="contato.telefone_quatro_sms"
                    label="Permite o envio de SMS?"
                />
            </div>

            <div class="row mt-3">
                <form-input grid="6" v-model="contato.email" label="E-mail" />

                <form-select
                    grid="6"
                    v-model="contato.email_tipo"
                    :itens="$root.arrays.tipo_contato_email"
                    label="Tipo do E-mail"
                />

                <form-toggle
                    mt="1"
                    v-model="contato.email_envio"
                    label="Permite o envio de notificações via e-mail?"
                />
            </div>

            <!--
            Regra temporariamente desativada:
            v-if="
            item.estado_cadastral_id != 4 &&
            item.estado_cadastral_id != 5
            "
            -->

            <div
                class="row pt-4 px-2 d-flex justify-content-end"
            >
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="item.cadastrarContato"
                    label="Cadastrar novas informações de Contato?"
                />
                <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    @click="submit"
                >
                    <i class="mdi mdi-content-save"></i>
                    {{ $t("Salvar") }}
                </button>
            </div>
        </div>
        <div v-else>
            <Historico
                @voltar="show_historico = false"
                :familia-id="$route.params.id"
            />
        </div>
    </div>
</template>
<script>
import Historico from "../../historico/Contato";
export default {
    components: { Historico },
    props: ["item"],
    data() {
        return {
            show_historico: false,
            contato: {
                telefone_um: "",
                telefone_um_tipo: "",
                telefone_um_sms: "",
                resp_tel_um: "",
                telefone_dois: "",
                telefone_dois_tipo: "",
                telefone_dois_sms: "",
                resp_tel_dois: "",
                telefone_tres: "",
                telefone_tres_tipo: "",
                telefone_tres_sms: "",
                resp_tel_tres: "",
                telefone_quatro: "",
                telefone_quatro_tipo: "",
                telefone_quatro_sms: "",
                resp_tel_quatro: "",
                email: "",
                email_tipo: "",
                email_envio: ""
            }
        };
    },
    mounted() {
        if (Array.isArray(this.item.contatos) && this.item.contatos.length) {
            this.contato = this.item.contatos[0]; // Acessa o primeiro item do array
        }
    },
    methods: {
        submit() {
            var str =
                this.item.cadastrarContato == 1
                    ? "Tem certeza que deseja cadastrar novas informações de Contato ?"
                    : "Tem certeza que deseja atualizar as informações de Contato?";
            swal.fire({
                text: str,
                showDenyButton: true,
                confirmButtonText: `Salvar`,
                denyButtonText: `Não salvar`
            }).then(result => {
                if (result.isConfirmed) {
                    this.item.contatos = this.contato;
                    this.$emit("submit");
                    this.$snack.success({
                        button: false,
                        text: "Contato salvo com sucesso."
                    });
                }
            });
        }
    }
};
</script>
